import type { DictShape } from './en';

export const uk: DictShape = {
  // navigation rail
  nav_home: 'Головна',
  nav_all_pages: 'Усі сторінки',
  nav_categories: 'Категорії',
  nav_recent_changes: 'Нові зміни',
  nav_reports: 'Звіти',
  nav_map: 'Карта світу',
  nav_random: 'Випадкова сторінка',
  nav_relations: "Зв'язки",
  nav_aria_label: 'Навігація',
  nav_create_page: 'Створити сторінку',
  // sidebar / page list
  sidebar_aria_label: 'Сторінки',
  sidebar_nav_label: 'Список сторінок',
  // locale switcher
  lang_switcher_label: 'Мова інтерфейсу',
  // top bar / search
  search_placeholder: 'Пошук',
  search_no_results: 'Нічого не знайдено.',
  search_empty: 'Нічого не знайдено.',
  search_pages_one: '1 сторінка',
  search_pages_many: '{{count}} сторінок',
  search_loading: 'Завантаження',
  search_searching: 'Пошук',
  // auth / account panel
  auth_login: 'Увійти',
  auth_logout: 'Вийти',
  auth_register: 'Реєстрація',
  auth_change_password: 'Пароль',
  auth_moderation: 'Модерація',
  auth_panel_label: 'Учасник',
  auth_login_to_propose: 'Увійдіть, щоб запропонувати правку.',
  auth_propose_edit: 'Запропонувати правку',
  auth_pending_count: '{{count}} очікує модерації',
  auth_contributor_access: 'Contributor access',
  auth_account_security: 'Account security',
  auth_email: 'Пошта',
  auth_password_label: 'Пароль',
  auth_logging_in: 'Входимо',
  auth_passwords_mismatch: 'Паролі не збігаються.',
  auth_confirm_password: 'Повторіть пароль',
  auth_creating_account: 'Створюємо',
  auth_create_account: 'Створити акаунт',
  auth_already_have_account: 'Вже є акаунт',
  auth_error_login: 'Не вдалося увійти.',
  auth_error_register: 'Не вдалося зареєструватися.',
  auth_contributor_required: 'Потрібен вхід учасника.',
  auth_password_account_hint: 'Пароль можна змінити лише для поточного акаунта.',
  auth_current_password: 'Поточний пароль',
  auth_new_password: 'Новий пароль',
  auth_saving: 'Зберігаємо',
  auth_save: 'Зберегти',
  auth_cancel: 'Скасувати',
  auth_new_passwords_mismatch: 'Новий пароль і підтвердження не збігаються.',
  auth_password_changed: 'Пароль змінено.',
  auth_error_change_password: 'Не вдалося змінити пароль.',
  // graph / relations panel
  graph_relations_title: "Зв'язки",
  graph_hide_btn: "Сховати зв'язки",
  graph_svg_label: 'Граф сторінок',
  graph_backlinks: 'Зворотні посилання',
  graph_loading: "Завантаження зв'язків.",
  graph_empty: 'Поки немає.',
  // table of contents
  toc_title: 'Зміст',
  toc_show: '[показати]',
  toc_hide: '[сховати]',
  // reader / article
  reader_loading: 'Завантаження…',
  reader_not_found: 'Сторінку не знайдено',
  reader_stub: 'Це заготовка сторінки.',
  reader_read: 'Читати',
  reader_edit: 'Редагувати',
  reader_history: 'Історія',
  reader_propose_missing: 'Запропонувати сторінку',
  reader_home: 'Головна',
  reader_breadcrumbs_label: 'Навігаційний ланцюжок',
  reader_page_loading: 'Завантаження сторінки.',
  reader_redirected_from: 'Перенаправлено з',
  reader_redirect_loop: 'Ця сторінка утворює цикл перенаправлень.',
  reader_page_empty: 'Ця сторінка поки що порожня.',
  reader_categories_label: 'Категорії:',
  reader_published_prefix: 'Опубліковано',
  reader_page_stub: 'Заготовка',
  reader_missing_lang: 'Сторінку не знайдено на {{lang}}.',
  reader_propose_translation: 'Запропонувати переклад',
  reader_no_pages: 'Немає опублікованих сторінок.',
  reader_page_missing: 'Сторінки «{{slug}}» ще немає.',
  reader_relevant_label: "Пов'язані сторінки",
  reader_relevant_page: 'Сторінка',
  reader_relevant_link: "Зв'язок",
  reader_relevant_mutual: 'взаємний',
  reader_relevant_inbound: 'посилається сюди',
  reader_relevant_outbound: 'посилання',
  reader_other_langs_label: 'Інші мови',
  reader_other_langs: 'Інші мови:',
  reader_info: 'Інформація',
  // page information panel
  page_info_title: 'Інформація про сторінку',
  page_info_revisions: 'Правки',
  page_info_contributors: 'Учасники',
  page_info_inbound: 'Вхідні посилання',
  page_info_outbound: 'Вихідні посилання',
  page_info_categories: 'Категорії',
  page_info_created: 'Створено',
  page_info_updated: 'Оновлено',
  page_info_current_revision: 'Поточна версія',
  page_info_translations: 'Переклади',
  page_info_loading: 'Завантаження інформації.',
  page_info_error: 'Не вдалося завантажити інформацію про сторінку.',
  page_info_back: '← Читати',
  page_info_none: '—',
  // propose / edit
  propose_new_label: 'New proposal',
  propose_edit_label: 'Edit proposal',
  propose_new_title: 'Нова сторінка',
  propose_edit_title: 'Правка: {{title}}',
  propose_submit: 'Надіслати пропозицію',
  propose_cancel: 'Скасувати',
  propose_login_required: 'Увійдіть, щоб запропонувати сторінку.',
  propose_contributor_required: 'Потрібен вхід учасника.',
  propose_hint: 'Правки зберігаються як пропозиції та чекають модерації.',
  propose_page_loading: 'Завантаження сторінки для правки.',
  propose_page_not_found: 'Сторінку для правки не знайдено.',
  propose_title_label: 'Назва',
  propose_categories_label: 'Категорії',
  propose_categories_placeholder: 'Через кому, напр. Лор, Війна',
  propose_translation_key_label: 'Ключ перекладу',
  propose_translation_key_placeholder: 'Спільний ключ, що зв’язує сторінку між мовами',
  propose_summary_label: 'Короткий опис',
  propose_summary_placeholder: 'Що змінилося',
  propose_target_page: 'Цільова сторінка',
  propose_image_label: 'Зображення',
  propose_upload_label: 'Завантажити зображення',
  propose_uploading: 'Завантаження зображення',
  propose_image_hint: 'JPEG, PNG або WebP до 10 MB',
  propose_awaiting: 'Очікує модерації',
  propose_submitting: 'Надсилаємо',
  propose_error_login: 'Увійдіть, щоб надіслати пропозицію.',
  propose_error_expired: 'Сесія закінчилася. Увійдіть знову.',
  propose_error_submit: 'Не вдалося надіслати пропозицію.',
  propose_error_upload: 'Не вдалося завантажити зображення.',
  // markdown preview
  preview_empty: "Попередній перегляд з'явиться після введення тексту.",
  // moderation
  moderation_title: 'Модерація',
  moderation_no_proposals: 'Немає пропозицій на модерацію.',
  moderation_queue_title: 'Черга пропозицій',
  moderation_moderator_required: 'Потрібен вхід модератора.',
  moderation_moderator_hint: 'Черга пропозицій відкрита лише для редакційної ролі.',
  moderation_queue_label: 'Черга пропозицій',
  moderation_pending_label: 'Очікуючі',
  moderation_queue_loading: 'Завантаження черги.',
  moderation_load_more_loading: 'Завантаження',
  moderation_load_more: 'Ще',
  moderation_select: 'Виберіть пропозицію з черги.',
  moderation_approve_loading: 'Публікуємо',
  moderation_approve: 'Схвалити',
  moderation_reject_loading: 'Відхиляємо',
  moderation_reject: 'Відхилити',
  moderation_diff_loading: 'Завантаження diff.',
  moderation_back: 'Черга',
  moderation_forbidden: 'Немає доступу до модерації.',
  moderation_forbidden_hint: 'Потрібна роль moderator, superadmin або scope wiki moderation.',
  moderation_error_load: 'Не вдалося завантажити чергу модерації.',
  moderation_error_diff: 'Не вдалося завантажити diff пропозиції.',
  moderation_error_load_more: 'Не вдалося завантажити наступну сторінку.',
  moderation_error_session: 'Сесія закінчилася. Увійдіть знову.',
  moderation_error_decision: 'Не вдалося зберегти рішення.',
  moderation_confirm_approve: 'схвалити',
  moderation_confirm_reject: 'відхилити',
  moderation_confirm: 'Підтвердіть: {{action}} пропозицію "{{label}}"?',
  moderation_approved: 'Схвалено: {{label}}.',
  moderation_approved_revision: ' Ревізія {{id}}.',
  moderation_rejected: 'Відхилено: {{label}}.',
  // categories
  categories_title: 'Категорії',
  // page indexes
  page_index_all: 'Усі сторінки',
  page_index_recent: 'Нові зміни',
  page_index_empty: 'Ще немає опублікованих сторінок.',
  page_index_recent_empty: 'Ще немає нових змін.',
  page_index_loading: 'Завантаження сторінок.',
  page_index_page_count_one: '1 сторінка',
  page_index_page_count_many: '{{count}} сторінок',
  page_index_updated: 'Оновлено {{date}}',
  page_index_stub: 'заготовка',
  // map
  map_title: 'Карта світу',
  map_loading: 'Завантаження карти.',
  map_canvas_label: 'Карта світу',
  map_canvas_links_label: 'Посилання на сторінки карти світу',
  map_preview_title: 'Карта світу',
  map_preview_link_label: 'Перейти до карти світу',
  map_preview_canvas_label: 'Карта світу — попередній перегляд',
  map_filter_label: 'Фільтр за категоріями',
  map_filter_all: 'Усі',
  // moderation metadata tooltips
  moderation_meta_lang: 'Мова контенту',
  moderation_meta_group: 'Група перекладів',
  // moderation proposal kind labels
  moderation_kind_new: 'Нова сторінка',
  moderation_kind_edit: 'Правка',
  moderation_proposal_label: 'Пропозиція',
  // markdown preview section heading
  propose_preview_label: 'Попередній перегляд',
  // propose field labels
  propose_slug_label: 'Slug',
  propose_markdown_label: 'Markdown',
  // revision history
  history_back: '← Читати',
  history_title: 'Історія: {{slug}}',
  history_loading_list: 'Завантаження історії.',
  history_no_revisions: 'Немає ревізій.',
  history_not_all: 'Показано не всі ревізії.',
  history_loading_revision: 'Завантаження ревізії.',
  history_old_version: 'Це стара версія сторінки.',
  history_compare: 'Порівняти з поточною',
  history_hide_compare: 'Сховати порівняння',
  history_error_load: 'Не вдалося завантажити історію.',
  history_error_revision: 'Не вдалося завантажити ревізію.',
  // categories index
  categories_index_kicker: 'Індекс',
  categories_loading: 'Завантаження категорій.',
  categories_empty: 'Поки немає категорій.',
  categories_page_count_one: '1 сторінка',
  categories_page_count_many: '{{count}} сторінок',
  categories_error_load: 'Не вдалося завантажити категорії.',
  // category view
  category_kicker: 'Категорія',
  category_loading: 'Завантаження сторінок.',
  category_empty: 'У цій категорії поки немає сторінок.',
  category_load_more_loading: 'Завантаження…',
  category_load_more: 'Ще',
  category_error_load: 'Не вдалося завантажити категорію.',
  // recent changes feed
  recent_changes_title: 'Свіжі правки',
  recent_changes_loading: 'Завантаження свіжих правок.',
  recent_changes_empty: 'Правок поки немає.',
  recent_changes_load_more: 'Ще',
  recent_changes_load_more_loading: 'Завантаження…',
  recent_changes_error_load: 'Не вдалося завантажити свіжі правки.',
  // reports
  reports_title: 'Звіти',
  reports_wanted: 'Відсутні сторінки',
  reports_orphans: 'Осиротілі сторінки',
  reports_dead_ends: 'Сторінки-глухий кут',
  reports_loading: 'Завантаження звіту.',
  reports_empty: 'У цьому звіті немає сторінок.',
  reports_error_load: 'Не вдалося завантажити звіт.',
  reports_count_one: '1 сторінка',
  reports_count_many: '{{count}} сторінок',
  // site statistics
  nav_stats: 'Статистика',
  stats_title: 'Статистика сайту',
  stats_published_pages: 'Опублікованих сторінок',
  stats_stub_pages: 'Заготовок',
  stats_total_revisions: 'Правок усього',
  stats_images: 'Завантажених зображень',
  stats_categories: 'Категорій',
  stats_accounts_by_role: 'Акаунти за роллю',
  stats_loading: 'Завантаження статистики.',
  stats_error_load: 'Не вдалося завантажити статистику.',
  // audit log
  audit_log_title: 'Журнал дій',
  audit_log_loading: 'Завантаження журналу.',
  audit_log_empty: 'Журнал порожній.',
  audit_log_error_load: 'Не вдалося завантажити журнал дій.',
  audit_action_proposal_approve: 'Схвалив пропозицію',
  audit_action_proposal_reject: 'Відхилив пропозицію',
  audit_action_user_role_change: 'Змінив роль користувача',
  audit_action_user_scope_change: 'Змінив права користувача',
  // watchlist
  nav_watchlist: 'Відстежуване',
  watch_follow: 'Стежити',
  watch_unfollow: 'Не стежити',
  watch_loading: 'Оновлення…',
  watch_login_required: 'Увійдіть, щоб стежити за сторінками.',
  watchlist_title: 'Відстежувані сторінки',
  watchlist_empty: 'Ви ще не стежите за жодною сторінкою.',
  watchlist_loading: 'Завантаження списку.',
  watchlist_error_load: 'Не вдалося завантажити список відстежуваних сторінок.',
  watch_error_follow: 'Не вдалося підписатися на сторінку.',
  watch_error_unfollow: 'Не вдалося відписатися від сторінки.',
  // notifications
  notifications_bell_label: 'Сповіщення',
  notifications_mark_all_read: 'Позначити всі як прочитані',
  notifications_empty: 'Немає сповіщень.',
  notifications_loading: 'Завантаження сповіщень.',
  notifications_error_load: 'Не вдалося завантажити сповіщення.',
  notification_kind_proposal_approved: 'Пропозицію схвалено',
  notification_kind_proposal_rejected: 'Пропозицію відхилено',
  notification_kind_page_published: 'Сторінку оновлено',
  // diff
  diff_no_changes: 'Немає відмінностей від базової ревізії.',
  // admin user management (superadmin only)
  nav_admin_users: 'Управління користувачами',
  admin_users_title: 'Управління користувачами',
  admin_users_filter_all: 'Усі користувачі',
  admin_users_filter_moderators: 'Модератори',
  admin_users_col_email: 'Email',
  admin_users_col_name: "Ім'я",
  admin_users_col_role: 'Роль',
  admin_users_col_created: 'Дата реєстрації',
  admin_users_promote: 'Зробити модератором',
  admin_users_demote: 'Зняти модератора',
  admin_users_updating: 'Оновлення…',
  admin_users_loading: 'Завантаження користувачів.',
  admin_users_error_load: 'Не вдалося завантажити користувачів.',
  admin_users_error_update: 'Не вдалося оновити роль.',
  admin_users_prev: '← Назад',
  admin_users_next: 'Вперед →',
  // errors
  error_load_pages: 'Не вдалося завантажити список сторінок.',
  error_load_page: 'Не вдалося завантажити сторінку.',
  error_load_graph: "Не вдалося завантажити зв'язки.",
  error_search: 'Пошук недоступний.',
  error_session_expired: 'Сесія закінчилася. Увійдіть знову.',
  error_login_required: 'Потрібен вхід.',
  error_moderator_required: 'Потрібен вхід модератора.',
};
